import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingLandlordForm({ updateLocation, users, landlordManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'landlord_ids',
          role: 'landlord',
          title: '项目外部管理人员',
          selectedUsers: landlordManager
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    landlordManager: selectors.getTeamRolesOfLocation(state, loc_id, 'landlord')
  };
}

export default connect(mapStateToProps)(LocationSettingLandlordForm);
